const data: { [index: string]: any } = {
  "gpt-35-turbo": "primary",
  "gpt-4-32k": "error",
  "gpt-4-8k": "success",
  "gpt-35-turbo-16k": "warning",
  "gpt-4-vision": "info",
};

export default data;
